import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";


const __default__ = {
    name: "ActionBlockOutputError"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    showIcon: { type: Boolean, default: true }
  },
  setup(__props: any) {


let props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({'text-muted mt-1': true, 'font-size-small': __props.showIcon}),
    style: {"white-space":"normal"}
  }, [
    (__props.showIcon)
      ? (_openBlock(), _createBlock(FontAwesomeIcon, {
          key: 0,
          icon: "exclamation-triangle",
          class: "text-danger mr-1"
        }))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})